var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('entity-select',{attrs:{"entities-config":{
    entities: _vm.actions,
    entitiesIcons: _vm.ActionIcons
  },"button-title":_vm.$t('create_action_button_create_title'),"popup-title":_vm.$t('create_action_create_popup_title'),"disabled":_vm.disabled},on:{"select":_vm.selectAction}})}
var staticRenderFns = []

export { render, staticRenderFns }